@if (stateValues) {
  <div>
    <h4><strong>Zip Code</strong></h4>
    <p>
      {{stateValues.zipCode}}
    </p>
    <h4><strong>County</strong></h4>
    <p>
      {{stateValues.county.county}}
    </p>
    <h4><strong>State</strong></h4>
    <p>
      {{stateValues.county.state}}
    </p>
  </div>
}